<div class="bg-white">
  <div class="modal-header" rt="video-modal-header" ngbAutofocus>
    <div class="w-100"></div>
    <i class="icon-close text-grey" id="icon-close" (click)="activeModal.dismiss()"></i>
  </div>
  <div class="modal-body p-0">
    <div class="embed-responsive embed-responsive-16by9">
      <iframe
        *ngIf="safeVideoUrl"
        class="embed-responsive-item"
        [src]="safeVideoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</div>
